export const TENANT = 'fpg-rcbp-ui'

export const globalWindow = window.top?.window ?? window

export const ROOT_ROUTE = '/rv/fpg/rcbp'
export const ROOT_ROUTE_PATTERN = '/rv/fpg?/rcbp'
export const ROOT_ROUTE_REGEX = '/rv(/fpg)?/rcbp'
export const API_CONFIG_KEY = 'apiConfig'
export const USER_SESSION_KEY = 'userState'
export const CONTACT_PERMISSION_KEY = 'hasContactPermission'
export const PHONE_CONTACTS_KEY = 'phoneContacts'
export const RUPEE = '₹'
export const DOT = '•'
export const INPUT_TAG = 'INPUT'

export const ANDROID_VERSION_WITH_FETCH_CONTACTS_SUPPORT = '1860207'
export const ANDROID_OS_VERSION_WITH_FK_UPI_SUPPORT = 7

export const FkpayProfiles = {
  CHECKOUT_BOTTOMSHEET: 'rcbp_express_checkout',
}

export const PULL_DOWN_TOP_THRESHOLD = 140
export const PULL_DOWN_BOTTOM_THRESHOLD = 0
export const TOP_BAR_HEIGHT = 165

export const FkpayEndpoints = {
  OPTIONS: '/fkpay/api/v3/payments/rcbp/options',
  OPTIONS_V2: '/fkpay/v5/payments/options',
  PAY: '/fkpay/api/v3/payments/paywithdetails',
  PAY_LATER_SELECT: '/fkpay/api/v3/payments/select/instrument',
  PAY_LATER_DECLINE: '/fkpay/api/v3/payments/decline/instrument',
  PAY_LATER_COMPLETE: '/fkpay/api/v3/payments/complete',
  VERIFY: '/fkpay/v5/payments/instrument/FK_UPI/verify',
  SEND_MONEY: '/fkpay/v5/payments/instrument/FKUPI/sendMoney',
}

export const UpiServiceEndpoints = {
  SEND_MONEY: '/upi/front/v1/checkout/transactions/send-money/submit',
  REFRESH_TOKEN: '/upi/front/v1/checkout/users/npci-token',
  UPI_FRONT_VERIFY: '/upi/front/v1/checkout/verify',
  UPI_FRONT_BANK_DETAILS: '/upi/front/v1/checkout/users/account-details/fetch',
}

export const FKUPIBusinessMetricEndPoints = {
  CHECKOUT_BUSINESS_EVENT: '/rcbp/checkout/events',
}

export const FKUPIEvents = {
  FK_UPI_ONBOARDING_INITIATED: 'FK_UPI_ONBOARDING_INITIATED',
  FK_UPI_ONBOARDING_COMPLETED: 'FK_UPI_ONBOARDING_COMPLETED',
  FK_UPI_OPTION: 'FK_UPI_OPTION',
}

export const BridgeMethods = {
  FETCH_UPI_APPS: 'fetchUPIApps',
  START_UPI_TRANSACTION: 'startUPITransaction',
  CHANGE_TOOL_BAR_VISIBILITY: 'changeToolBarVisibility',
  START_PHONEPE_TRANSACTION: 'startPhonePeTransaction',
  IS_PHONEPE_ENABLED_ON_DEVICE: 'isPhonePeEnabledOnDevice',
  IS_PHONEPE_SDK_ENABLED_ON_DEVICE: 'isPhonePeSDKEnabledOnDevice',
  VALIDATE_PHONEPE_USER: 'validatePhonePeUser',
  GET_SDK_VERSION_FROM_PHONEPE: 'getSDKVersionFromPhonePe',
  GET_DEVICE_ID_FROM_PHONEPE: 'getDeviceIdFromPhonePe',
  SELECT_CONTACT_FROM_PHONEBOOK: 'selectContactFromPhonebook',
  FETCH_CONTACT_FROM_PHONEBOOK: 'fetchContactsFromPhoneBook',
  FETCH_LIMITED_CONTACTS_FROM_PHONEBOOK: 'fetchLimitedContactsFromPhoneBook',
  GET_DEVICE_INFO: 'getDeviceInfoForFkUpi',
  GET_NPCI_TOKEN_INFO: 'getNpciTokenInfo',
  GET_NPCI_KEY_INFO: 'getNpciKeyInfo',
  GET_CHALLENGE: 'getChallenge',
  GET_CRED_BLOCK: 'getCredBlockForFkUpi',
  SAVE_NPCI_TOKEN_INFO: 'saveNpciTokenInfo',
  SAVE_NPCI_KEY_INFO: 'saveNpciKeyInfo',
}

export const QueryParams = {
  OPEN_CHECKOUT_BOTTOMSHEET: 'openRCBPCheckoutBottomsheet',
  CONNECTION_ID: 'connectionId',
  PLAN_ID: 'planId',
  ONBOARDING_TRIGGERED: 'onboardingTriggered',
}
